import React from 'react'
import classes from './CategoryMenu.module.scss'
import {withRouter} from "react-router-dom";
import useStore from "../../../../useStore";

const CategoryMenu = (props) => {

    const setSubCategory = useStore(state => state.getSubCategory)

    let listSubMenu = <p>No list data found</p>
    if (props.product_categories.length > 0) {
        let listItems = <p>No Items</p>
        listSubMenu = props.product_categories.map((prod_category, index) => {
            listItems = props.product_sub_categories.filter(x => x.product_category_cd === prod_category.product_category_cd).map(subCategory => {
                return (
                    <div key={`${subCategory.slug}${index}`}
                        // onClick={() => props.gotoPage(prod_category.slug, prod_category.id, subCategory.slug, subCategory.id, prod_category.name)}
                         onClick={() => {
                             props.gotoPage(prod_category.slug, prod_category.product_category_cd, subCategory.slug, subCategory.product_sub_category_cd, prod_category.name)
                             ;setSubCategory(prod_category.slug, subCategory.slug)
                         }}
                         style={{cursor: 'pointer'}}>
                        <li className={classes.MegaMenuContainer_liSubtitle}>{subCategory.name}</li>
                    </div>
                )
            });
            return (
                <ul key={`${prod_category.slug}${index}`} className={[].join(' ')}>
                    <div className={classes.MegaMenuContainer_categoryTitle}>
                        <div
                            // onClick={() => props.gotoPage(prod_category.slug, prod_category.id, 0, 0, prod_category.name)}
                            onClick={() => props.gotoPage(prod_category.slug, prod_category.product_category_cd, 0, 0, prod_category.name)}
                            style={{cursor: 'pointer'}}>
                            <img src={prod_category.image_icon} alt={""}/>&nbsp;<span>{prod_category.name}</span>
                        </div>
                    </div>
                    {listItems}
                </ul>
            )
        })
    }

    return (
        <React.Fragment>
            <div className={classes.Backdrop} onClick={props.toggleClosed}/>
            <div className={classes.MegaMenuContainer}>
                {props.product_categories && listSubMenu}
            </div>
        </React.Fragment>
    )//end return
}

export default withRouter(React.memo(CategoryMenu));